export default {
  "noMatches": "No matches",
  "copy": "Copy",
  "copied": "Copied!",
  "hide": "Hide",
  "show": "Show",
  "save": "Save",
  "saving": "Saving...",
  "cancel": "Cancel",
  "retry": "Retry",
  "loading": "Loading...",
  "active": "Active",
  "error": "Error",
  "configured": "Configured",
  "notConfigured": "Not configured",
  "noChangesToSave": "No changes to save",
  "credentialsSaved": "Credentials saved",
  "failedToSave": "Failed to save",
  "failedToSaveCredentials": "Failed to save credentials",
  "instance": "Instance:",
  "apiKeyCaption": "API Key:",
  "apiKey": "API Key",
  "telemetry": "Telemetry",
  "parameters": "Parameters",
  "executing": "Executing...",
  "execute": "Execute",
  "response": "Response",
  "history": "History",
  "clear": "Clear",
  "read": "Read",
  "write": "Write",
  "none": "None",
  "db": "DB",
  "env": "Env",
  "key": "Key",
  "rotate": "Rotate",
  "generate": "Generate",
  "never": "Never",
  "success": "Success",
  "pending": "Pending",
  "send": "Send",
  "status": "Status:",
  "cron": "Cron:",
  "disabled": "Disabled",
  "schedule": "Schedule:",
  "set": "Set",
  "sending": "Sending...",
  "sendTest": "Send Test",
  "hourly": "Hourly",
  "custom": "Custom",
  "pageTitle": "API Control Center",
  "nerveCenter": "Nerve Center",
  "pageDescription": "Manage API credentials, telemetry, local keys, and test endpoints.",
  "searchEndpoints": "Search endpoints...",
  "allCategories": "All Categories",
  "noEndpoints": "No endpoints available",
  "endpointCount_one": "{{shown}} of {{displayCount}} endpoint",
  "endpointCount_other": "{{shown}} of {{displayCount}} endpoints",
  "selectEndpoint": "Select an endpoint",
  "chooseEndpoint": "Choose an endpoint from the list to test",
  "copyResponse": "Copy response",
  "playground": "API Playground",
  "playgroundHelp": "Test API endpoints in a safe sandbox",
  "requestHistory": "Request History",
  "registryUnavailable": "The endpoint registry could not be loaded",
  "noInstance": "No instance ID",
  "instanceId": "Instance ID",
  "instancePlaceholder": "Enter your instance ID",
  "replaceKey": "Enter new key to replace",
  "enterKey": "Enter your API key",
  "credentialsHelp": "Credentials are used for dashboard updates and telemetry.",
  "telemetryOn": "Telemetry on",
  "telemetryOff": "Telemetry off",
  "rotateReadTitle": "Rotate Read Key",
  "rotateWriteTitle": "Rotate Write Key",
  "clearReadTitle": "Clear Read Key",
  "clearWriteTitle": "Clear Write Key",
  "rotateWarning": "This will generate a new key. The current key will stop working immediately.",
  "clearWarning": "This will remove the database-stored key. The system will fall back to the environment variable if configured.",
  "readKey": "Read Key",
  "writeKey": "Write Key",
  "viewKey": "View Key",
  "revealKey": "Click to reveal key",
  "storedKeyHelp": "Keys stored in the database can be revealed anytime. Use the toggle to show/hide.",
  "localKeys": "Local API Keys",
  "localKeysSubtitle": "Read and write authentication keys",
  "keyHelp": "Read keys allow querying data. Write keys allow modifications. Database keys override environment variables.",
  "notSent": "Not sent yet",
  "sendTestTitle": "Send Test Telemetry",
  "sendTestConfirm": "This will send a telemetry heartbeat to QuickBox Central using your configured credentials. Continue?",
  "heartbeatSubtitle": "Heartbeat to QuickBox Central",
  "lastSent": "Last sent:",
  "editSchedule": "Edit cron schedule",
  "heartbeatSchedule": "Heartbeat Schedule",
  "customCron": "Custom cron expression:",
  "cronUnavailable": "Cron management not available. The helper script may not be installed.",
  "generatingPayload": "Generating Payload...",
  "hidePayload": "Hide Payload",
  "previewPayload": "Preview Payload",
  "telemetryPayload": "telemetry payload",
  "telemetryHelp": "Telemetry sends periodic heartbeats to QuickBox Central for license validation. No sensitive data is transmitted.",
  "every5": "Every 5 minutes",
  "every10": "Every 10 minutes",
  "every15": "Every 15 minutes",
  "every30": "Every 30 minutes",
  "registryFailed": "Failed to load endpoint registry",
  "rateLimited": "Rate limited. Please wait a moment.",
  "requestFailed": "Request failed",
  "executeFailed": "Failed to execute request",
  "clearHistoryFailed": "Failed to clear history",
  "historyCleared": "History cleared",
  "settingsFailed": "Failed to load API settings",
  "telemetryUpdateFailed": "Failed to update telemetry",
  "telemetryEnabled": "Telemetry enabled",
  "telemetryDisabled": "Telemetry disabled",
  "payloadFailed": "Failed to get telemetry payload",
  "telemetryTestFailed": "Telemetry test failed",
  "telemetrySent": "Telemetry sent successfully",
  "telemetrySendFailed": "Failed to send test telemetry",
  "readRotateFailed": "Failed to rotate read key",
  "writeRotateFailed": "Failed to rotate write key",
  "readRotated": "Read key rotated",
  "writeRotated": "Write key rotated",
  "readClearFailed": "Failed to clear read key",
  "writeClearFailed": "Failed to clear write key",
  "readCleared": "Read key cleared",
  "writeCleared": "Write key cleared",
  "readRevealFailed": "Failed to reveal read key",
  "writeRevealFailed": "Failed to reveal write key",
  "cronStatusFailed": "Failed to update cron status",
  "cronEnabled": "Cron enabled",
  "cronDisabled": "Cron disabled",
  "cronScheduleFailed": "Failed to update cron schedule",
  "cronScheduleUpdated": "Cron schedule updated",
  "milliseconds": "{{value}} ms",
  "justNow": "just now",
  "paramString": "string",
  "paramNumber": "number",
  "paramBoolean": "boolean",
  "locationQuery": "query",
  "locationBody": "body",
  "authRead": "read",
  "authWrite": "write",
  "authAdmin": "admin",
  "editCredentials": "Edit credentials"
} as const;
